export const condition = {
  EQUAL: 'equal',
  GT: 'greater-than',
  LT: 'lower-than',
};

export const postType = {
  ALL: 'all',
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'videos',
};

export const filterType = {
  KEYWORD: 'keyword',
  METRIC: 'metric',
  POST_TYPE: 'postType',
  ONLY_BADGES: 'onlyBadges',
};

export const sortDirection = {
  ASC: 'asc',
  DESC: 'desc',
};

export const sortType = {
  PERFORMANCE: 'performance',
  LIKES: 'likes',
  COMMENTS: 'comments',
  CLICKS: 'clicks',
  SHARES: 'shares',
  IMPRESSIONS: 'impressions',
  VIDEO_VIEWS: 'videos',
};

export const filterMetricOption = {
  likes: {
    icon: 'likes',
    label: 'Likes',
    value: 'likes',
    color: '#FF5860',
  },
  comments: {
    icon: 'comments',
    label: 'Comments',
    value: 'comments',
    color: '#1D9DEE',
  },
  impressions: {
    icon: 'impressions',
    label: 'Impressions',
    value: 'impressions',
    color: '#FF9600',
  },
  shares: {
    icon: 'shares',
    label: 'Shares',
    value: 'shares',
    color: '#1282AE',
  },
  clicks: {
    icon: 'clicks',
    label: 'Clickthrough',
    value: 'clicks',
    color: '#DD56FF',
  },
  [sortType.VIDEO_VIEWS]: {
    icon: 'camera',
    label: 'Video Views',
    value: 'videos',
    color: '#5179E1',
  },
};

export const badgeType = {
  FIRST: 'first',
  SECOND: 'second',
  THIRD: 'third',
  WORST_FIRST: 'worst-first',
  WORST_SECOND: 'worst-second',
  WORST_THIRD: 'worst-third',
  IMPRESSIONS: 'impressions',
  COMMENTS: 'comments',
  LIKES: 'likes',
  CLICKS: 'clicks',
};

export const mapBadgeToContent = {
  [badgeType.FIRST]: {
    color: '#846AFA',
    text: '#1 Top Performer',
    icon: 'gold-star',
  },
  [badgeType.SECOND]: {
    color: '#846AFA',
    text: '#2 Top Performer',
    icon: 'silver-star',
  },
  [badgeType.THIRD]: {
    color: '#846AFA',
    text: '#3 Top Performer',
    icon: 'bronze-star',
  },
  [badgeType.WORST_FIRST]: {
    color: '#D54C19',
    text: '#1 Worst Performer',
    icon: 'thumb-down',
  },
  [badgeType.WORST_SECOND]: {
    color: '#D54C19',
    text: '#2 Worst Performer',
    icon: 'thumb-down',
  },
  [badgeType.WORST_THIRD]: {
    color: '#D54C19',
    text: '#3 Worst Performer',
    icon: 'thumb-down',
  },
  [badgeType.LIKES]: {
    color: '#FF5860',
    text: 'Highest Likes',
    icon: 'likes',
  },
  [badgeType.COMMENTS]: {
    color: '#1D9DEE',
    text: 'Highest Comments',
    icon: 'comments',
  },
  [badgeType.IMPRESSIONS]: {
    color: '#FF9600',
    text: 'Highest Impressions',
    icon: 'impressions',
  },
  [badgeType.CLICKS]: {
    color: '#DD56FF',
    text: 'Highest Clicks',
    icon: 'clicks',
  },
};

export const mapBadgeToTooltip = {
  [badgeType.FIRST]: 'Best performer',
  [badgeType.SECOND]: '2nd best performer',
  [badgeType.THIRD]: '3rd best performer',
  [badgeType.WORST_FIRST]: 'Worst performer',
  [badgeType.WORST_SECOND]: '2nd worst performer',
  [badgeType.WORST_THIRD]: '3rd worst performer',
  [badgeType.LIKES]: 'Most likes',
  [badgeType.COMMENTS]: 'Most comments',
  [badgeType.IMPRESSIONS]: 'Highest impressions',
  [badgeType.CLICKS]: 'Highest clicks',
};
